module.exports = __webpack_public_path__ + "static/media/are-you-sure.7bd4f2fb.png";